import { BusinessGoalApi } from "~/api/BusinessGoal";


export function useBusinessGoalApi(): BusinessGoalApi {
    const businessGoalApi = new BusinessGoalApi(useHttpClient());
    
  return businessGoalApi;
}
